import { render, staticRenderFns } from "./termTable.vue?vue&type=template&id=0a9837d3&scoped=true&"
import script from "./termTable.vue?vue&type=script&lang=js&"
export * from "./termTable.vue?vue&type=script&lang=js&"
import style0 from "./termTable.vue?vue&type=style&index=0&id=0a9837d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9837d3",
  null
  
)

export default component.exports